//nav
const nav = document.querySelector('nav');
const el = document.querySelectorAll('details[id^="Details-HeaderMenu-"]');
el.forEach((item) => {
  // マウスホバー時の挙動
  item.addEventListener('mouseenter', () => {
    item.setAttribute('open', '');
  });

  item.addEventListener('mouseleave', () => {
    item.removeAttribute('open');
  });
});

//外部リンク
const links = document.querySelectorAll('a');
for (let i = 0; i < links.length; i++) {
  const href = links[i].getAttribute('href');
  if (!href || href.trim() === '' || href.trim() === '#' || href.trim().toLowerCase().startsWith('javascript:') || href.trim().toLowerCase().startsWith('mailto:') || href.trim().toLowerCase().startsWith('tel:')) {
    continue;
  }

  // .pdf で終わる場合は常に target="_blank"
  if (href.trim().toLowerCase().endsWith('.pdf')) {
    links[i].target = '_blank';
    links[i].rel = 'noopener';
    continue;
  }

  // 外部リンクの場合のみ
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noopener';
  }
}

//年連認証
const AGE_AUTH_KEY = 'isAgeVerified';
const ageModal = document.getElementById('ageCheck');
const yesBtn = document.getElementById('age-yes');
const footerGroup = document.querySelector('.shopify-section-group-footer-group');

// ageModalがなければ何もしない
// footerグループ自体が非表示の場合も何もしない
if (!ageModal || !footerGroup || getComputedStyle(footerGroup).display === 'none') {
} else {
  // クエリパラメータを取得
  const params = new URLSearchParams(window.location.search);
  const hasContinue = params.has('continue');

  if (hasContinue) {
    // クエリがあれば、認証済みにする
    sessionStorage.setItem(AGE_AUTH_KEY, 'true');
  } else if (!sessionStorage.getItem(AGE_AUTH_KEY)) {
    // モーダル表示
    ageModal.removeAttribute('aria-hidden');
    ageModal.classList.add('ageCheckModal--open');
    document.body.style.overflow = 'hidden';
    // フォーカスをモーダルに
    ageModal.focus();

    yesBtn.addEventListener('click', () => {
      sessionStorage.setItem(AGE_AUTH_KEY, 'true');
      ageModal.classList.remove('ageCheckModal--open');
      document.body.style.overflow = '';
    });
  }
}

//ページTOPに戻るボタン
const backToTopButton = document.querySelector('.back-to-top');
if (backToTopButton) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) {
      backToTopButton.classList.add('is-active');
    } else {
      backToTopButton.classList.remove('is-active');
    }
  });
}
